<template>
    <base-dialog :loading="loading" :value="dialog" :title="$t('common.filter_exercises')" :width="420" @input="onInput" @close="hide">
        <div class="filter-fields">
            <kimsa-combobox :label="$t('exercises.category')" :placeholder="$t('exercises.pick_one_category')" dense
                :items="categoriesOptions" @change="category = $event" placeholder-class :value="category"
                item-text="label" ref="category" />
            <kimsa-combobox :label="$t('exercises.types')" :placeholder="$t('exercises.pick_type')" dense
                :items="typesOptions" item-text="label" @change="types = $event" placeholder-class multiple-with-chips
                :readonly="!category" :value="types" ref="types" />
        </div>

        <template #footer>
            <dialog-actions :cancel-label="$t('common.reset')" :confirm-label="$t('common.filter')" @cancel="reset"
                @confirm="applyFilter" />
        </template>
    </base-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import KimsaCombobox from './inputs/KimsaCombobox.vue';
import BaseDialog from './BaseDialog.vue';
import DialogActions from './DialogActions.vue';

export default {
    components: { KimsaCombobox, BaseDialog, DialogActions },
    name: "FilterExercisesDialog",
    data() {
        return {
            dialog: false,
            loading: false,
            category: null,
            types: [],
        }
    },
    computed: {
        ...mapState(['categoriesOptions']),
        typesOptions(vm = this) {
            if (!vm.category) return []
            return vm.category.types.map(type => ({ name: type, value: type, label: vm.typeLabel(type) })).sort((a, b) => a.label.localeCompare(b.label))
        },
    },
    async mounted() {
        const vm = this
        if (vm.categoriesOptions.length === 0) await vm.fetchExerciseCategories()
    },
    methods: {
        ...mapActions(['fetchExerciseCategories']),
        show(filter = null) {
            const vm = this
            vm.category = filter?.category || null
            vm.types = filter?.types || []
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.category = null
            vm.types = []
            vm.$emit('filter')
            vm.hide()
        },
        applyFilter() {
            const vm = this;
            let payload = {
                category: vm.category,
                types: vm.types,
            }
            vm.$emit('filter', payload)
            vm.hide()
        }
    },
}
</script>

<style scoped>
.filter-fields {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
</style>
